import HttpProxy from "@/services/HttpProxy";

export default class ReportService {
  static async get(parameters) {
    const response = await HttpProxy.submit({
      method: "get",
      url: "/BusinessInfo/Reports",
      parameters,
    });
    return response?.data ?? null;
  }
}
